import React from 'react';
import './index.css';
import Clockin from '../../components/Clockin';
import ActivityRule from '../../components/ActivityRule';

class App extends React.Component {
    render () {
        return (
            <div className="homePage">
                <div className="homePage-content">
                    <Clockin />
                    <ActivityRule />
                </div>
            </div>
        );
    }
}

export default App;
